<template>
  <div>
    <template v-if="type === 1">
      <div class="ft-22-333 se-m-b-30">
        {{ step === 1 ? "上传课件" : "题目设计" }}
      </div>
      <template v-if="step === 1">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="80px"
          label-position="left"
          style="width: 50%"
        >
          <el-form-item label="课件名称" prop="courseName">
            <el-input v-model="form.courseName"></el-input>
          </el-form-item>
          <div class="se-flex">
            <div class="se-required">*</div>
            <el-form-item label="课件封面" prop="coverUrl">
              <el-upload
                name="file"
                class="avatar-uploader"
                accept=".png,.jpg,.jpeg,.gif"
                :action="`${baseURL}server/common/upload`"
                :headers="headers"
                list-type="picture-card"
                :limit="1"
                :file-list="coverList"
                :on-remove="removeCover('coverUrl')"
                :on-success="
                  (res, file, fileList) =>
                    uploadSuccess(res, file, fileList, 'coverUrl', 'coverList')
                "
              >
                <div class="se-p-t-15 se-p-b-15">
                  <i
                    class="el-icon-plus"
                    style="font-size: 12px; color: #e44352"
                  ></i>
                  <div style="font-size: 12px; color: #e44352">上传</div>
                </div>
              </el-upload>
            </el-form-item>
          </div>
          <el-form-item label="专业分类" required prop="sepcialty">
            <el-cascader
              v-model="form.sepcialty"
              style="width: 100%"
              :options="options"
              :props="classIfyProp"
              @change="classIfyChange"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="课件内容" prop="courseSummary">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="form.courseSummary"
            >
            </el-input>
          </el-form-item>
          <div class="se-flex">
            <div class="se-required">*</div>
            <el-form-item label="课件视频" prop="videoUrl">
              <div v-loading="uploadLoading">
                <el-upload
                  name="file"
                  v-model="form.videoUrl"
                  accept=".mp4, .ogg, .webm"
                  class="avatar-uploader"
                  :action="`${dataObj.host}`"
                  :file-list="videoList"
                  :limit="1"
                  :data="dataObj"
                  :before-upload="videoBeforeUpload"
                  :on-remove="removeCover('videoUrl')"
                  :on-success="videoSuccess"
                >
                  <div class="se-flex aic se-upload-btn jcc">
                    <i
                      class="el-icon-plus"
                      style="font-size: 12px; color: #e44352"
                    ></i>
                    <div class="ft-12-red se-m-l-5">上传视频</div>
                  </div>
                  <div
                    slot="tip"
                    class="el-upload__tip"
                    style="white-space: nowrap"
                  >
                    支持扩展名：.mp4,.ogg,.webm格式:文件最大不超过5G。
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </div>
          <el-form-item label="有无讲师" required>
            <el-radio-group v-model="hasTeacher" @change="switchChange">
              <el-radio :label="true">有</el-radio>
              <el-radio :label="false">无</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="hasTeacher" label="讲师类型" required>
            <el-radio-group v-model="form.teacherType">
              <el-radio :label="1">内部讲师</el-radio>
              <el-radio :label="2">外部讲师</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="(form.teacherType === 1) & hasTeacher"
            label="讲师选择"
            required
          >
            <el-button type="text" @click="isShowAddTea(teaObj)">{{
              teaObj ? teaObj.persionName : "请选择主讲老师"
            }}</el-button>
          </el-form-item>
          <el-form-item
            v-if="form.teacherType === 2 && hasTeacher"
            label="讲师姓名"
            required
          >
            <el-input v-model="form.teacherName"></el-input>
          </el-form-item>
          <el-form-item label="课件文件">
            <el-upload
              name="file"
              multiple
              class="avatar-uploader"
              accept=".pdf, .ppt, .pptx, .doc , .docx , .xls , .xlsx"
              :action="`${dataObj.host}`"
              :data="dataObj"
              :file-list="fileList"
              :on-remove="onRemove"
              :before-upload="beforeUpload"
              :on-success="uploadFileSuccess"
            >
              <div class="se-flex aic se-upload-btn jcc">
                <i
                  class="el-icon-plus"
                  style="font-size: 12px; color: #e44352"
                ></i>
                <div class="ft-12-red se-m-l-5">上传文件</div>
              </div>
              <div slot="tip" class="el-upload__tip">
                支持扩展名：.doc .docx .pdf .ppt .pptx.xls
                .xlsx；请不要上传空文件
              </div>
            </el-upload>
          </el-form-item>
          <!-- <el-form-item label="考试题目">
          <div class="se-upload-btn ft-12-red cp" @click="type = 2">
            题目设计
          </div>
        </el-form-item> -->
          <el-form-item label="评价模板" required>
            <div class="se-flex">
              <div class="se-m-r-20">
                {{
                  evaTemplate.templateName ? evaTemplate.templateName : "请选择"
                }}
              </div>
              <el-button
                v-if="evaTemplate.templateName"
                type="text"
                @click="delTemplate"
                >删除</el-button
              >
            </div>
            <el-button type="danger" size="small" @click="visible = true"
              >选择评价模版</el-button
            >
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
        <div class="se-flex">
          <el-button
            type="danger"
            :loading="loading"
            style="width: 120px"
            @click="saveCourse"
            >下一步</el-button
          >
          <el-button style="width: 120px" @click="goBack">取消</el-button>
        </div>
      </template>
      <template v-else>
        <topic-design
          :courseId="uploadCourseId"
          @back="step--"
          @goHome="goHome"
        ></topic-design>
        <!-- <el-button style="margin-right: 20px" type="danger">
          批量添加
        </el-button>
        <el-button
          style="margin-right: 20px"
          type="danger"
          @click="importIsShow"
        >
          导入题库
        </el-button>
        <el-button
          style="margin-right: 20px"
          type="danger"
          @click="importIsShow"
        >
          导入题库
        </el-button> -->
      </template>
    </template>
    <!-- <template v-if="type === 2">
      <topic-design @back="back"></topic-design>
    </template> -->
    <!-- 选择评价模版对话框 -->
    <el-dialog title="选择评价模板" :visible.sync="visible" width="60%">
      <select-template ref="evaTepRef" @sendData="sendData"></select-template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="danger" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 选老师对话框 -->
    <el-dialog title="添加讲师" :visible.sync="studentVisible" width="60%">
      <add-teacher
        :teaType="form.teacherType"
        :planUserIds="planUserIds"
        ref="addTeacher"
        @sendTeacher="sendTeacher"
      ></add-teacher>
      <span slot="footer" class="dialog-footer">
        <el-button @click="studentVisible = false">取 消</el-button>
        <el-button type="danger" @click="studentConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import topicDesign from "./topicDesign.vue";
import selectTemplate from "./selectTemplate.vue";
import addTeacher from "./addTeacher.vue";
import { baseURL } from "@/utils/request";

export default {
  components: {
    topicDesign,
    selectTemplate,
    addTeacher,
  },

  props: {
    auditStatusType: {
      type: String,
      default: "",
    },
    courseId: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      baseURL,
      headers: {
        Authorization: `Bearer ${this.$store.state.token}`,
      },
      evaList: [],
      coverList: [],
      videoList: [],
      rules: {
        courseName: [
          { required: true, message: "请输入课件名称", trigger: "blur" },
        ],
        // coverUrl: [
        //   { required: true, message: "请上传课件封面", trigger: "change" },
        // ],
        sepcialty: [
          { required: true, message: "请选择专业分类", trigger: "blur" },
        ],
        // videoUrl: [
        //   { required: true, message: "请上传课件视频", trigger: "change" },
        // ],
        evaluationTemplateId: [
          { required: true, message: "请选择评价模版", trigger: "blur" },
        ],
        courseSummary: [
          { required: true, message: "请输入课件内容", trigger: "blur" },
        ],
      },
      form: {
        courseName: "",
        sepcialty: "",
        courseSummary: "",
        coverUrl: "",
        videoUrl: "",
        trainCourseFiles: [],
        evaluationTemplateId: "",
        viewTime: 0,
        teacherId: JSON.parse(localStorage.getItem("userInfo")).userId,
        id: null,
        teacherType: 1,
        teacherName: "",
      },
      seeBigVisible: false,
      dialogImageUrl: "",
      value: "",
      fileList: [],
      speList: [],
      typeList: [
        {
          label: "工程",
          value: 1,
        },
      ],
      type: 1,
      visible: false,
      uploadCourseId: "a6082017ed25490d82295da7fefbffe2",
      step: 1,
      viewTime: undefined,
      loading: false,
      options: [],
      classIfyProp: {
        expandTrigger: "hover",
        value: "id",
        label: "specialtyName",
        children: "cmsSpecialtyList",
      },
      evaTemplate: {},
      uploadLoading: false,
      dataObj: {
        policy: "",
        signature: "",
        key: "",
        OSSAccessKeyId: "",
        dir: "",
        host: "",
      },
      hasTeacher: true,
      teaObj: {
        persionName: JSON.parse(localStorage.getItem("userInfo")).persionName,
        userId: JSON.parse(localStorage.getItem("userInfo")).userId,
      },
      studentVisible: false,
      teaType: null,
      planUserIds: null,
    };
  },

  watch: {
    "form.teacherType"(newValue) {
      // console.log(newValue, 'newValue')
      if (newValue === 1) {
        this.teaObj = {
          persionName: JSON.parse(localStorage.getItem("userInfo")).persionName,
          userId: JSON.parse(localStorage.getItem("userInfo")).userId,
        };
        this.form.teacherId = JSON.parse(
          localStorage.getItem("userInfo")
        ).userId;
        this.form.teacherName = "";
      } else {
        this.teaObj = undefined;
        this.form.teacherId = null;
      }
    },
  },

  mounted() {
    // this.getEvaluateTemplateList();
    this.getSpecialty();
    this.getInfo();
  },

  methods: {
    mouseenter() {
      this.displayFlag = true;
    },
    mouseleave() {
      this.displayFlag = false;
    },
    getClassOptionTitle(e) {
      // console.log(e, "e");
    },
    // 分类选择变化回调
    classIfyChange(e) {
      this.form.sepcialty = e[e.length - 1];
      // console.log(this.form.sepcialty, "this.form.sepcialty");
    },

    // 初始化分类数据
    initOptions(data) {
      data.forEach((v) => {
        if (v.cmsSpecialtyList.length === 0) {
          delete v.cmsSpecialtyList;
        } else {
          this.initOptions(v.cmsSpecialtyList);
        }
      });
      return data;
    },

    // 获取分类
    getSpecialty() {
      this.$http.get("server/portal/home/specialty").then((res) => {
        if (res.status == 200) {
          // this.options = this.initOptions(res.data);
          this.options = res.data.filter(
            (v) => v.cmsSpecialtyList.length !== 0
          );
          this.options = this.initOptions(this.options);
          // this.options.forEach((v) => {
          //   if (!v.cmsSpecialtyList) v.disabled = true;
          // });
          // this.options.filter((v) => !v.cmsSpecialtyList);
        }
      });
    },

    goHome() {
      this.$emit("goHome");
    },
    removeCover(key) {
      // this.form[key] = "";
    },
    saveCourse() {
      if (!this.form.coverUrl) {
        this.$message.info("请上传封面图");
        return;
      }
      if (!this.form.videoUrl) {
        this.$message.info("请上视频");
        return;
      }

      if (!this.form.evaluationTemplateId) {
        this.$message.info("请选择评价模版");
      }

      // if (this.hasTeacher && !this.form.teacherId) {
      //   this.$message.info("请选择讲师");
      //   return;
      // }

      if (
        this.hasTeacher &&
        this.form.teacherType === 1 &&
        !this.form.teacherId
      ) {
        this.$message.info("请选择讲师");
        return;
      }

      if (
        this.hasTeacher &&
        this.form.teacherType === 2 &&
        !this.form.teacherName
      ) {
        this.$message.info("请输入讲师姓名");
        return;
      }

      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          if (this.$route.query.auditStatusType === "add") {
            this.form.viewTime = this.viewTime;
            try {
              const {
                data: { id },
              } = await this.$http.post(
                "server/portal/personCenter/addMyCourse",
                this.form
              );
              this.uploadCourseId = id;
              this.step = 2;
            } catch (error) {
              this.loading = false;
            }
          } else {
            if (this.coverList.length) {
              this.form.coverUrl = this.coverList[0].url;
            }
            if (this.videoList.length) {
              this.form.videoUrl = this.videoList[0].url;
            }
            try {
              const data = await this.$http.put("server/api/course", this.form);
              // console.log(data, "data8888");
              this.uploadCourseId = data.data.data.id;
              this.step = 2;
            } catch (error) {
              this.loading = false;
            }
          }
        } else {
          // console.log("error submit!!");
          return false;
        }
        this.loading = false;
      });
    },

    // 上传文件成功回调
    uploadFileSuccess(res, file, fileList) {
      // console.log(res, "res");
      // console.log(file, "file");
      // console.log(fileList, "fileList");
      // if (file.code === 200) {
      //   this.form.trainCourseFiles = fileList.map((s) => {
      //     return {
      //       fileName: s.name,
      //       fileUrl: s.response.url,
      //       uid: s.uid,
      //     };
      //   });
      // }
      if (file.status === "success") {
        const obj = {};
        obj.fileUrl = `${this.dataObj.host}/${this.dataObj.dir}${file.name}`;
        obj.fileName = file.name;
        obj.uid = file.uid;
        this.form.trainCourseFiles.push(obj);
        // console.log(this.form.trainCourseFiles, "this.form.trainCourseFiles");
      }
    },

    onRemove(file, fileList) {
      this.form.trainCourseFiles = fileList.map((s) => {
        return {
          fileName: s.name,
          fileUrl: s.response.url,
          uid: s.uid,
        };
      });
    },

    uploadSuccess(res, file, fileList, key, list) {
      const that = this;
      if (file.response.code === 200) {
        this.form[key] = file.response.url;
        this[list] = [
          {
            name: file.name,
            url: file.response.url,
            uid: file.uid,
          },
        ];
        if (key === "videoUrl") {
          const video = document.createElement("video");
          video.style.display = "none";
          video.src = file.response.url;
          document.body.appendChild(video);
          video.addEventListener(
            "canplay",
            (e) => {
              that.viewTime = video.duration;
              document.body.removeChild(video);
            },
            false
          );
        }
        that.uploadLoading = false;
      }
    },

    async getSpecialtyList() {
      const res = await this.$http.get("server/api/specialty/list");
      this.speList = res.rows;
    },

    async getEvaluateTemplateList() {
      const res = await this.$http.get(
        "server/portal/personCenter/evaluateTemplateList"
      );
      this.evaList = res.rows;
    },

    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.seeBigVisible = true;
    },

    handlePreview(file) {
      // console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    // 返回上一级
    goBack() {
      this.$emit("back");
    },

    // 取消题目设计
    back() {
      this.type = 1;
    },

    // 展示选择评价模板对话框
    isShow() {
      this.visible = true;
    },

    // 编辑获取数据
    async getInfo() {
      // console.log(this.auditStatusType, "this.auditStatusType");
      if (this.auditStatusType === "edit") {
        const res = await this.$http.get(
          `server/portal/personCenter/getMyCourseDetails/${this.courseId}`
        );
        this.form.courseName = res.data.courseName;
        this.form.sepcialty = res.data.sepcialty;
        this.form.id = res.data.id;
        this.form.courseSummary = res.data.courseSummary;
        this.form.viewTime = res.data.viewTime;
        // console.log(this.form.viewTime, "this.form.viewTime");
        this.form.evaluationTemplateId = res.data.evaluationTemplateId;
        this.evaTemplate = res.data.trainCourseEvaTmpl;
        this.form.trainCourseFiles = res.data.trainCourseFiles;
        this.fileList = res.data.trainCourseFiles.map((v) => {
          return {
            name: v.fileName,
            url: v.fileUrl,
            uid: v.id,
          };
        });
        this.form.coverUrl = res.data.coverUrl;
        this.form.videoUrl = res.data.videoUrl;
        // console.log(this.form, "form");
        this.coverList = [
          {
            name: "img",
            url: res.data.coverUrl,
            uid: res.data.id + "img",
          },
        ];

        const name =
          res.data.videoUrl.split("/")[res.data.videoUrl.split("/").length - 1];
        this.videoList = [
          {
            name,
            url: res.data.videoUrl,
            uid: res.data.id + "video",
          },
        ];

        if (!data.hasTeacher) {
          this.hasTeacher = false;
        } else {
          if (data.teacherType === 2) {
            this.form.teacherName = data.teacherName;
          } else {
            this.form.teacherId = data.teacherId;
            this.teaObj = {
              persionName: data.teacherName,
              userId: data.teacherId,
            };
          }
        }
      }
    },

    // 删除已选择的评价模板
    delTemplate() {
      this.evaTemplate = {};
      this.form.evaluationTemplateId = null;
    },

    // 选择模版确认
    confirm() {
      this.$refs.evaTepRef.confirm();
    },

    // 接收选择的模版
    sendData(value) {
      this.evaTemplate = value;
      this.form.evaluationTemplateId = value.id;
      this.visible = false;
    },

    // 获取签名
    async getSign() {
      const res = await this.$http.get("server/ossSignature");
      return res;
    },
    checkType(file) {
      const typeList = ["mp4", "MP4", "ogg", "webm"];
      const arr = file.name.split(".");
      const type = arr[arr.length - 1];
      return typeList.includes(type);
    },
    // 视频上传前置钩子
    videoBeforeUpload(file) {
      return new Promise(async (resolve, reject) => {
        const isType = this.checkType(file);
        if (!isType) {
          this.$message.error("请上传符合格式的视频");
          return reject(file);
        }
        const { data } = await this.getSign();
        this.dataObj.key = `${data.dir}${file.name}`;
        this.dataObj.policy = data.policy;
        this.dataObj.OSSAccessKeyId = data.accessid;
        this.dataObj.success_action_status = "200";
        this.dataObj.signature = data.signature;
        this.dataObj.host = data.host;
        this.dataObj.dir = data.dir;
        resolve(true);
      });
    },

    // 文件上传前置钩子
    async beforeUpload(file) {
      console.log(file, "file");
      const { data } = await this.getSign();
      this.dataObj.key = `${data.dir}${file.name}`;
      this.dataObj.policy = data.policy;
      this.dataObj.OSSAccessKeyId = data.accessid;
      this.dataObj.success_action_status = "200";
      this.dataObj.signature = data.signature;
      this.dataObj.host = data.host;
      this.dataObj.dir = data.dir;
    },

    videoSuccess(response, file, fileList) {
      // console.log(response, "response");
      // console.log(file, "file");
      // console.log(fileList, "fileList");
      this.form.videoUrl = `${this.dataObj.host}/${this.dataObj.dir}${file.name}`;
      const that = this;
      const video = document.createElement("video");
      video.style.display = "none";
      video.src = this.form.videoUrl;
      document.body.appendChild(video);
      video.addEventListener(
        "canplay",
        (e) => {
          that.viewTime = video.duration;
          document.body.removeChild(video);
        },
        false
      );
    },

    // 有无讲师切换
    switchChange(e) {
      console.log(e);
      if (e) {
        this.teaObj = {
          persionName: JSON.parse(localStorage.getItem("userInfo")).persionName,
          userId: JSON.parse(localStorage.getItem("userInfo")).userId,
        };
      } else {
        this.teaObj = undefined;
      }
    },

    // 展示选人对话框
    isShowAddTea(teaObj) {
      if (teaObj) this.planUserIds = Number(teaObj.userId);
      this.taaType = this.form.teacherType;
      console.log(this.planUserIds, "planUserIds");
      this.studentVisible = true;
    },

    // 选人确认
    studentConfirm() {
      this.$refs.addTeacher.confirm();
    },

    sendTeacher(value) {
      this.teaObj = {
        persionName: value.persionName,
        userId: value.userId,
      };
      this.studentVisible = false;
      console.log(value, "value");
    },
  },
};
</script>

<style lang="scss" scoped>
.se-upload-btn {
  width: 110px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #e44352;
}

/deep/ .el-upload--picture-card {
  width: 70px;
  height: 70px;
  line-height: 20px;
  border: 1px dashed #e44352;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 70px;
  height: 70px;
}

item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

.se-required {
  color: #f56c6c;
  margin-right: 4px;
  padding-top: 10px;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #f56c6c;
  background: #f56c6c;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #f56c6c;
}

/deep/ .el-button--text {
  color: #f56c6c;
}
</style>
